import React from 'react';
import { useAtom } from 'jotai';
import {
  LOCALE_META,
  SUPPORTED_LOCALES,
  localeAtom,
  isLocalizationVisible,
  useFeatureHubData
} from '@cyberint/common-utils';
import { VerticalMenu, Icons, Themes, Flag } from '@cyberint/dsc';
import { t } from '../../../i18n';
import * as S from './styled';

const paperSx = {
  backgroundColor: 'var(--secondaryBgColor)',
  backdropFilter: 'none',
  border: '1px solid var(--cadetGray)'
};

const LanguageSwitcherImpl = () => {
  const [locale, setLocale] = useAtom(localeAtom);
  const current = LOCALE_META[locale] || LOCALE_META.en;

  const onPick = next => {
    if (next === locale || typeof window === 'undefined') return;
    setLocale(next); // this writees to localstorage
    setTimeout(() => window.location.reload(), 20);
  };

  const options = SUPPORTED_LOCALES.map(code => {
    const meta = LOCALE_META[code];
    return {
      value: code,
      label: (
        <S.OptionRow>
          <Flag code={meta.country} alt={meta.label} size={18} />
          <S.NativeLabel>{meta.nativeLabel}</S.NativeLabel>
          <S.SubLabel>{meta.label}</S.SubLabel>
        </S.OptionRow>
      ),
      selected: code === locale,
      testId: `language-switcher-option-${code}`
    };
  });

  return (
    <S.Wrapper>
      <VerticalMenu
        testId="language-switcher-toggle"
        options={options}
        onSelect={onPick}
        isCloseAfterSelect
        mode={Themes.DARK}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        paperSx={paperSx}>
        <S.Trigger
          as="div"
          role="button"
          aria-haspopup="menu"
          aria-label={t('topbar.languageSwitcher.ariaLabel', { lang: current.label })}>
          <Flag code={current.country} alt={current.label} size={18} />
          <Icons.DownArrow size="S" />
        </S.Trigger>
      </VerticalMenu>
    </S.Wrapper>
  );
};

export const LanguageSwitcherBase = () => {
  const { flags } = useFeatureHubData();
  if (!isLocalizationVisible({ flags })) return null;
  return <LanguageSwitcherImpl />;
};
